'use strict';

const { h } = require('phy');
// eslint-disable-next-line import/no-extraneous-dependencies
const { useState, useEffect } = require('preact/hooks');
const ChevronRightSvg =
  require('@design-system/ui-icons/preact/ChevronRight').default;
const Calendar = require('@design-system/ui-icons/preact/Calendar').default;

function shouldShowCheckScheduleButton(option) {
  return option.clientLinks?.[0]?.linkType === 'pre_purchase_booking';
}

function renderDesktop({
  bloodhoundData,
  checkScheduleText,
  bookingLink,
  hbwPreBookVisitText,
}) {
  return h(
    '.hbw-pre-purchase-wrapper',
    h('.hbw-message', hbwPreBookVisitText),
    h(
      '.check-schedule-btn-wrapper',
      h(
        'a.btn.btn-secondary.buy-button.check-schedule-btn',
        { ...bloodhoundData, href: bookingLink },
        checkScheduleText
      )
    )
  );
}

function renderTouch({
  bloodhoundData,
  checkScheduleText,
  bookingLink,
  hbwPreBookVisitText,
}) {
  return h(
    'a.hbw-pre-purchase-wrapper.check-schedule-btn',
    { ...bloodhoundData, href: bookingLink },
    h('.hbw-calendar-icon', h(Calendar)),
    h(
      '.check-schedule-btn-wrapper',
      h('.hbw-message', hbwPreBookVisitText),
      h('.check-schedule-button-text', checkScheduleText)
    ),
    h('.hbw-right-arrow', h(ChevronRightSvg, { width: '20px', height: '20px' }))
  );
}

function HBWBookingLink(props) {
  const [currentOptionUuid, setCurrentOptionUuid] = useState(
    props.multiOption?.[0]?.uuid
  );

  useEffect(() => {
    const { BuyButtonEventPipe } = window;
    if (
      BuyButtonEventPipe &&
      BuyButtonEventPipe.eventsHash.has('option_updated')
    ) {
      BuyButtonEventPipe.on('option_updated', ({ optionUuid }) => {
        setCurrentOptionUuid(optionUuid);
      });
    }
  });

  const { hbwPrePurchaseData, touchRequest, is3PIPDeal, multiOption } = props;
  const currentOption = multiOption.filter(
    option => option.uuid === currentOptionUuid
  )[0];

  if (!shouldShowCheckScheduleButton(currentOption)) {
    return null;
  }

  const clientLink = currentOption.clientLinks?.[0];
  const bookingLink = clientLink?.url;
  let { hbwPreBookVisitText, checkScheduleText } = hbwPrePurchaseData;
  hbwPreBookVisitText = clientLink?.description || hbwPreBookVisitText;
  checkScheduleText = clientLink?.title || checkScheduleText;

  const bloodhoundData = {
    'data-bhw': 'CheckDates',
    'data-bhd': `{ "thirdPartyDeal" : ${is3PIPDeal} }`,
  };

  const renderData = {
    bloodhoundData,
    checkScheduleText,
    bookingLink,
    hbwPreBookVisitText,
  };

  return touchRequest ? renderTouch(renderData) : renderDesktop(renderData);
}

module.exports = HBWBookingLink;
